var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.107 30V19.225H3v-4.389h5.107v-1.559H3v-4.29h5.107V2h11.6c3.04 0 5.292.71 6.75 2.13 1.46 1.407 2.19 3.578 2.19 6.513 0 2.225-.537 4.014-1.615 5.367-1.079 1.339-2.577 2.27-4.502 2.794L29.056 30h-6.035l-5.994-10.754H13.55V30H8.107zm5.443-15.156h6.874c1.705 0 2.558-.932 2.558-2.794V9.175c0-.938-.191-1.608-.574-2.011-.367-.415-1.03-.623-1.984-.623H13.55v8.304z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsr);
export default __webpack_public_path__ + "static/media/RSR.2760e98efa1eea82f215b3fc4fc376a8.svg";
export { ForwardRef as ReactComponent };